/**
 * useSupportContact — Task #14-FE
 *
 * Sendet eine Support-Kontaktanfrage via POST /api/v2/support/contact.
 * Typen aus @heliumtracker/api-types.
 */
import { useMutation } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'
import type { components } from '@heliumtracker/api-types'

export type SupportContactBody =
  components['schemas'] extends { SupportContact: infer T }
    ? T
    : { subject: string; message: string }

export type SupportContactInput = {
  subject: string
  message: string
}

export function useSupportContact() {
  return useMutation({
    mutationFn: async (data: SupportContactInput) => {
      const result = await apiClient.POST('/api/v2/support/contact', {
        body: data,
      })
      if (result.error) throw result.error
      return result.data
    },
  })
}
